<template>
    <div style="margin-bottom: 65px">
        <el-card class="box-card">
            <div slot="header"
                 style="display: flex;align-items: center;">
                <el-avatar size="small"
                           :src="avatar"></el-avatar>
                <span style="padding-left: 10px">{{username}} 的店铺</span>
            </div>
            <div>
                <waterfall :col='2'
                           :data="commodity">
                    <template>
                        <div style="padding: 4px"
                             v-for="(o, index) in commodity"
                             :key="index">
                            <a :href="o.address">
                                <el-card :body-style="{ padding: '0px' }"
                                         shadow="never">
                                    <img :src="o.image"
                                         class="image">
                                    <div style="padding: 0.2rem;">
                                        <span>{{o.name}}</span>
                                        <div class="bottom clearfix">
                                            <time class="price">{{ o.price.split("~")[0] }}</time>
                                        </div>
                                    </div>
                                </el-card>
                            </a>
                        </div>
                    </template>
                </waterfall>
            </div>
        </el-card>
    </div>
</template>

<script>
export default {
    name: "",
    data () {
        return {
            username: "",
            avatar: "",
            commodity: []
        }
    },
    mounted () {
        let userId = this.$route.query.userId;

        this.axios.get("/live/commodity/user?userId=" + userId).then(res => {
            this.username = res.data.data.username;
            this.avatar = res.data.data.avatar;
            this.commodity = res.data.data.commodity;
        })
    }
}
</script>

<style scoped>
.price {
    font-size: 13px;
    color: #ff0036;
    vertical-align: middle;
}

.bottom {
    margin-top: 13px;
    line-height: 12px;
}

.button {
    padding: 0;
    float: right;
}

.image {
    width: 100%;
    display: block;
}

.clearfix:before,
.clearfix:after {
    display: table;
    content: "";
}

.clearfix:after {
    clear: both;
}
</style>
